import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LinksClient, ServiceCategory, ShortDataLink, ShortDataLinkType } from "orderme-api-integration-client";
import { createLinksClient, ServiceClient } from "../../helpers/client";

interface CategoriesState {
    categories: ServiceCategory[],
    goodsCategory: ServiceCategory,
    loaded: boolean
}

const servicesClient: ServiceClient = new ServiceClient();

export const loadCategories = createAsyncThunk(
    'categories/load',
    async (_: void, thunkAPI) => {
        try {
            var categories = await servicesClient.getCategories();
            thunkAPI.dispatch(updateCategories(categories));
        }
        catch (error) {
            console.error(error);
        }

        return true;
    },
)

const initialState = {
    categories: [] as ServiceCategory[],
    goodsCategory: null,
    loaded: false
} as CategoriesState;

const categoriesSlice = createSlice({
    name: 'categories',
    initialState: initialState,
    reducers: {
        updateCategories: (state, action: PayloadAction<ServiceCategory[]>) => {
            state.categories = action.payload;
            state.goodsCategory = action.payload.find(category => category.itemsOnly);
        },
        clearCategories: state => {
            state.loaded = false;
            state.categories = [];
            state.goodsCategory = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(loadCategories.fulfilled, (state, action) => {
            state.loaded = true;
        });
        builder.addCase(loadCategories.pending, (state) => {
            state.loaded = false;
        });
        builder.addCase(loadCategories.rejected, (state) => {
            state.loaded = true;
        });
    },
})

export const { updateCategories, clearCategories } = categoriesSlice.actions
export default categoriesSlice.reducer